import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClientWH } from '@shared/services/ApiClient';
import { createHttpClient } from '@adapters/HttpClient';
import { useMemo } from 'react';
import { CartApiAdapter } from '../adapters/CartApiAdapter';
import { CreateCartRequest, Cart } from '../models/Cart';
import { CartService } from '../services/CartService';

export const useCreateCart = () => {
  const queryClient = useQueryClient();

  // 🎯 Memoizar instancias del servicio para evitar recrearlas en cada render
  const cartService = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CartApiAdapter(httpClient);
    return new CartService(apiAdapter);
  }, []);

  return useMutation<Cart, Error, CreateCartRequest>({
    mutationFn: (data: CreateCartRequest) => cartService.createCart(data),
    onSuccess: () => {
      // 🎯 Invalidar todas las queries de carts para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['carts'] });
    },
  });
};
